module.exports = __webpack_public_path__ + "static/media/6_portrait.31a060a1.jpg";